<div style="position:relative; top: 8px; right: 8px;">
  <div style="position: relative; float: right; height: 0" class="link-button">
    <a class="muted7" (click)="cancel()"><img src="./assets/images/close.svg" class="filter-invert" /></a>
  </div>
</div>
<table class="w-hundred">
  <th id="quote-form-left-nav" class="th-display-none"></th>
  <tbody>
    <tr>
      <td width="262" class="model-left-nav">
        <modal-left-nav [(nav)]="leftNav" (onClick)="clickLeftNav($event)"></modal-left-nav>
      </td>
      <td class="model-left-nav">
        <div class="modal-body-custom">
          <div class="medium large-text" style="padding-top: 10px">
            <div style="display:inline-block">
              <span (click)="logForm()">{{title}} {{isAdding == true || model?.number == null ? '' : '#' +
                model?.number}}</span> {{isAdding ? '(New)' : '(Edit)'}}
            </div>
            <div style="text-align: right">
              <ng-container *ngFor="let b of getButtons">
                <ng-container *ngIf="b.key == 'draft' && isAdding">
                  <button *ngIf="b.key == 'draft' && isAdding" pButton [label]="b.label"
                    [class]="'custom-button-compact ' + (b.class ? b.class : '')" type="button" (click)="click(b.key)"
                    [disabled]="!canAddDraft" style="margin-left: 7px"></button>
                </ng-container>
                <ng-container *ngIf="!isAdding || b.key != 'draft'">
                  <button *ngIf="b.validate === true" pButton [label]="b.label"
                    [class]="'custom-button-compact ' + (b.class ? b.class : '')" type="button" (click)="click(b.key)"
                    [disabled]="formInvalid" style="margin-left: 7px"></button>
                  <button *ngIf="b.validate === false" pButton [label]="b.label"
                    [class]="'custom-button-compact ' + (b.class ? b.class : '')" type="button" (click)="click(b.key)"
                    style="margin-left: 7px"></button>
                </ng-container>
              </ng-container>
            </div>
          </div>
          <div style="border-bottom: 1px solid #B4B4B4; padding-top:10px; margin-bottom: 10px;">

          </div>
          <!-- <loading *ngIf="isLoading"></loading> -->
          <ng-container *ngIf="!isLoading">

            <ng-container [ngSwitch]="leftNavSelected">
              <div *ngSwitchCase="'customer'" class="large-text">
                Customer
              </div>
              <div *ngSwitchCase="'vehicles'" class="large-text">
                Vehicles
              </div>
              <div *ngSwitchCase="'pickup'" class="large-text">
                Pickup
              </div>
              <div *ngSwitchCase="'delivery'" class="large-text">
                Delivery
              </div>
              <div *ngSwitchCase="'billing'" class="large-text">
                Billing
              </div>
              <div *ngSwitchCase="'notes'" class="large-text">
                Notes
              </div>
            </ng-container>


            <form [formGroup]="form" (ngSubmit)="save()">
              <simple-control [form]="form" key="id" type="hidden"></simple-control>

              <table class="form-table">
                <thead>
                  <tr>
                    <th id="quote-form-customerFirstName"style="width: 35%"></th>
                    <th id="quote-form-customerLastName"></th>
                  </tr>
                </thead>

                <tbody [hidden]="leftNavSelected != 'customer'">
                  <tr>
                    <td>{{metadata['customerFirstName']}}</td>
                    <td>
                      <simple-control [label]="metadata['customerFirstName']" [form]="form" key="customerFirstName"
                        type="text" [required]="true"></simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['customerLastName']}}</td>
                    <td>
                      <simple-control [label]="metadata['customerLastName']" [form]="form" key="customerLastName"
                        type="text" [required]="true"></simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['customerBusinessName']}}</td>
                    <td>
                      <simple-control [label]="metadata['customerBusinessName']" [form]="form"
                        key="customerBusinessName" type="text"></simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['customerBusinessHours']}}</td>
                    <td>
                      <simple-control [label]="metadata['customerBusinessHours']" [form]="form"
                        key="customerBusinessHours" type="textarea"></simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['customerEmail']}}</td>
                    <td>
                      <simple-control [label]="metadata['customerEmail']" [form]="form" key="customerEmail" type="text"
                        [required]="true"></simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['customerAddress1']}}</td>
                    <td>
                      <simple-control [label]="metadata['customerAddress1']" [form]="form" key="customerAddress1"
                        type="text"></simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['customerCity']}}</td>
                    <td>
                      <simple-control [label]="metadata['customerCity']" [form]="form" key="customerCity" type="text">
                      </simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['customerStateCode']}}</td>
                    <td>
                      <simple-control [label]="metadata['customerStateCode']" [form]="form" key="customerStateCode"
                        type="lookup" [items]="lookups.stateCode"></simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['customerZip']}}</td>
                    <td>
                      <simple-control [label]="metadata['customerZip']" [form]="form" key="customerZip" type="zip">
                      </simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['customerPhoneType']}}</td>
                    <td>
                      <simple-control [label]="metadata['customerPhoneType']" [form]="form" key="customerPhoneType"
                        type="lookup" [items]="lookups.phoneType"></simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['customerPhone']}}</td>
                    <td>
                      <simple-control [label]="metadata['customerPhone']" [form]="form" key="customerPhone"
                        type="phone"></simple-control>
                    </td>
                  </tr>
                </tbody>

                <tbody [hidden]="leftNavSelected != 'pickup'">
                  <tr>
                    <td>{{metadata['customerExpectedPickup']}}</td>
                    <td>
                      <simple-control [label]="metadata['customerExpectedPickup']" [form]="form"
                        key="customerExpectedPickup" type="text"></simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['pickupCity']}}</td>
                    <td>
                      <simple-control [label]="metadata['pickupCity']" [form]="form" key="pickupCity" type="text"
                        [required]="true"></simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['pickupStateCode']}}</td>
                    <td>
                      <simple-control [label]="metadata['pickupStateCode']" [form]="form" key="pickupStateCode"
                        type="lookup" [items]="lookups.stateCode" [required]="true"></simple-control>
                    </td>
                  </tr>
                </tbody>

                <tbody [hidden]="leftNavSelected != 'delivery'">
                  <tr>
                    <td>{{metadata['customerExpectedDelivery']}}</td>
                    <td>
                      <simple-control [label]="metadata['customerExpectedDelivery']" [form]="form"
                        key="customerExpectedDelivery" type="text"></simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['deliveryCity']}}</td>
                    <td>
                      <simple-control [label]="metadata['deliveryCity']" [form]="form" key="deliveryCity" type="text"
                        [required]="true"></simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['deliveryStateCode']}}</td>
                    <td>
                      <simple-control [label]="metadata['deliveryStateCode']" [form]="form" key="deliveryStateCode"
                        type="lookup" [items]="lookups.stateCode" [required]="true"></simple-control>
                    </td>
                  </tr>
                </tbody>

                <tbody [hidden]="leftNavSelected != 'billing'">
                  <tr>
                    <td>{{metadata['price']}}</td>
                    <td>
                      <simple-control [label]="metadata['price']" [form]="form" key="price" type="currency"
                        [required]="true"></simple-control>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['specialInstructions']}}</td>
                    <td>
                      <simple-control [label]="metadata['specialInstructions']" [form]="form" key="specialInstructions"
                        type="textarea"></simple-control>
                    </td>
                  </tr>
                </tbody>

                <tbody [hidden]="leftNavSelected != 'vehicles'">
                  <tr>
                    <td>{{metadata['openEnclosed']}}</td>
                    <td>
                      <simple-control [label]="metadata['openEnclosed']" [form]="form" key="openEnclosed" type="radio"
                        [items]="lookups.openEnclosed" [required]="true"></simple-control>
                    </td>
                  </tr>
                </tbody>
              </table>

              <ng-container *ngIf="leftNavSelected == 'vehicles'">
                <vehicles-form [form]="form" (countChange)="countChange('vehicles', $event)" [useQuoteForm]="true">
                </vehicles-form>
                <div *ngIf="form.contains('vehicles') && form.get('vehicles').length < 1" class="small-text italic"
                  style="color:#b00; text-align: right; width: 100%; display: inline-block">
                  <img src="./assets/images/alert.svg"/> Please add at least 1 vehicle
                </div>
              </ng-container>

              <div [hidden]="leftNavSelected != 'notes'">
                <notes [entityName]="'Quote'" [entityId]="id" (rowsChange)="newNotes = $event"></notes>
              </div>
            </form>

          </ng-container>
        </div>
      </td>
    </tr>
  </tbody>
</table>

<div class="ui-dialog ui-dialog-footer">
  <div class="modal-footer-custom">
    <div class="link-button d-inline-block">
      <a class="muted7" (click)="cancel()">Cancel</a>
    </div>
    <div class="link-button float-right d-inline-block">
      <button *ngIf="navIndex > 0" class="link-button" type="submit" (click)="clickPrevious()">Previous</button>
      <button *ngIf="navIndex < (leftNav.length - 1)" class="link-button" type="submit"
        (click)="clickNext()">Next</button>
    </div>
  </div>
</div>
